function handleColorById(id, lighten = false) {
  if (id == 1) { /* orange */
    if (lighten) {
      return '#ffb05b';
    } else {
      return '#fa8a14';
    }
  }
  if (id == 2) { /* green */
    if (lighten) {
      return '#71a74c';
    } else {
      return '#44a900';
    }
  }
  if (id == 3) { /* red */
    if (lighten) {
      return '#db3d55';
    } else {
      return '#de0222';
    }
  }
  if (id == 4) { /* navy */
    if (lighten) {
      return '#2e5979';
    } else {
      return '#004578';
    }
  }
}

export { handleColorById }
